import React, { useState } from "react";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
import {  useNavigate, useSearchParams } from "react-router-dom";


import { Button, Form, Input } from "antd";

import BaseUrl from "../../../BaseUrl";
import { TailSpin } from "react-loader-spinner";
import Swal from "sweetalert2";
import { PostApi } from '../../../Helper/helper';


const Resetpass = () => {
  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  

  // Now you can use the token value in your component
  console.log(token);
  console.log(token, 'lklklk')
  const [loader, setLoader] = useState(false);
  const [password, setpassword] = useState("");
  const [password_confirmation, setpassword_confirmation] = useState("");
  // const [password, setPassword] = useState("");

  const formData = new FormData();

  formData.append("password", password);
  formData.append("password_confirmation", password_confirmation);
  formData.append("token", token);
  // formData.append("password", password);


  const reset = () => {
   
    setLoader(true);
    PostApi(`${BaseUrl.baseUrl}customer/reset/password`, formData)
    .then((resolve) => {
      // console.log(data.data.message, "minhaj");
        setLoader(false);
        console.log("resolve ==>", resolve.data.message);
        // console.log(resolve.data.token,'hahhaha')
        // console.log(resolve.data.data.id,'id')
        if (resolve?.data?.message === "Password Updated") {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: '',
            text: resolve.data.message,
            showConfirmButton: false,
            timer: 1500
          })
          navigate("/login");

        }
        
         else if (resolve?.data?.message === "Token Incorrect Or Token Expired") {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: resolve.data.message,
              });}

              else{
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: resolve?.data?.errors?.password_confirmation[0],
                  });}


              
        // localStorage.setItem("loginEmail", email);
        // localStorage.setItem("token", resolve.data.token);
        // localStorage.setItem("id", resolve.data.data.id);
      })
      .catch((error) => {
        setLoader(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          // text: resolve.data.data.message,
        });
        console.log("error ==>", error);
      });
  };

  return (
    <>
      <section className="vh-100 align-items-center justify-content-center d-flex login_bg">
        <div className="container">
          <div className="row align-items-center justify-content-center px-md-0 px-5">
            <div className="col box_shadow py-5 login_width">
              <h2 className="mb-4 text-light">Reset Password</h2>
              <Form
                name="basic"
                labelCol={{
                  span: 8,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                {/* <label className="d-block width-fit text-light">
                  Email address
                </label>
                <Form.Item
                  className="mb-2"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Email!",
                    },
                  ]}
                >
                  <Input
                    onChange={(e) => setEmail(e.target.value)}
                    className="py-2"
                    placeholder="Email"
                  />
                </Form.Item> */}
                <label className="d-block width-fit text-light">Password</label>
                <Form.Item
                  className="mb-2"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Password!",
                    },
                  ]}
                >
                  <Input.Password
                    onChange={(e) => setpassword(e.target.value)}
                    placeholder="Password"
                  />
                </Form.Item>
                <label className="d-block width-fit text-light">Password Confirmation</label>
                <Form.Item
                  className="mb-2"
                  name="password_confirmation"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your  Conformation Password!",
                    },
                  ]}
                >
                  <Input.Password
                    onChange={(e) => setpassword_confirmation(e.target.value)}
                    placeholder="Conformation Password"
                  />
                </Form.Item>
                {/*
                <Form.Item
                  name="remember"
                  valuePropName="checked"
                  className="width-fit"
                >
                  <Checkbox>Remember me</Checkbox>
                </Form.Item> */}

                {/* <span className="width-fit d-block text-light">
                  Don't have an account? &nbsp;
                  <Link to="/signup" className="text-light fw-bold">
                    Sign up
                  </Link>
                  <Link to="/signup" className="text-light fw-bold" style={{marginLeft:'86px'}}>
                  Forget Password
                  </Link>
                </span> */}

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="d-flex align-items-center me-auto mt-1"
                    onClick={reset}
                  >
                    Reset Password &nbsp;
                    {loader ? (
                      <TailSpin
                        height="20"
                        width="20"
                        color="#fff"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                      />
                    ) : null}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Resetpass;
